if (window.location) {
    var urlParams = new URLSearchParams(window.location.search);
    var params = {};
    urlParams.forEach(function (value, key) {
        if (key.includes("utm")) {
            params[key] = value;
        }
    });
    var utmUrl = $("#utmHiddenUrl").val();
    $.ajax({
        contentType: 'application/json',
        url: utmUrl,
        method: 'POST',
        data: JSON.stringify(params),
        dataType: 'json',
        success: function (data) {
            console.log('Success');
        },
        error: function () {

        }
    });
}
